import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  GcButtonComponent,
  GcIconComponent,
  GcModalComponent,
  GcTabComponent,
  GcTabsComponent,
  GcTooltipComponent,
  IpoButtonComponent,
  IpoCheckboxComponent,
  IpoFilterByPropertiesPipe,
  IpoFlexibleTableModule,
  IpoFormDatepickerComponent,
  IpoFormInputComponent,
  IpoIconAlertComponent,
  IpoInputComponent,
  IpoLanguageService,
  IpoLoadingSpinnerComponent,
  IpoModalComponent,
  IpoPageHeaderComponent,
  IpoPaginationComponent,
  IpoSkeletonComponent,
  IpoSortByPipe,
  IpoStringService,
  IpoTextComponent,
  IpoTranslateArrayPipe,
  IpoTranslatePipe,
  stringServiceFactory,
} from '@ip-only/front-end-library';
import { ErrorInformationComponent } from '../shared/error-information/error-information.component';
import { DetailedErrorFeedbackAlertComponent } from '../shared/feedback-alert/detailed-error-feedback-alert/detailed-error-feedback-alert.component';
import { FeedbackAlertComponent } from '../shared/feedback-alert/feedback-alert.component';
import { GcHeaderComponent } from '../shared/gc-header/gc-header.component';
import { CompleteReportConfirmationModalComponent } from '../shared/installation-report-content-v2/complete-report-confirmation-modal/complete-report-confirmation-modal.component';
import { SharedModule } from '../shared/shared.module';
import { InstallationReportingAppRouterModule } from './installation-reporting-app-routing.module';
import { InstallationReportModalV2Component } from './installation-reporting-wrapper/installation-report-modal-v2/installation-report-modal-v2.component';
import { GroupAgreementsTableComponent } from './installation-reporting-wrapper/installation-reporting-table/mdu/group-agreements-table.component';
import { InstallationReportingTableComponent } from './installation-reporting-wrapper/installation-reporting-table/sdu/installation-reporting-table.component';
import { InstallationReportingWrapperComponent } from './installation-reporting-wrapper/installation-reporting-wrapper.component';
import en from './strings.en';
import fi from './strings.fi';
import sv from './strings.sv';

@NgModule({
  declarations: [
    InstallationReportingWrapperComponent,
    InstallationReportingTableComponent,
    InstallationReportModalV2Component,
  ],
  imports: [
    CommonModule,
    InstallationReportingAppRouterModule,
    IpoLoadingSpinnerComponent,
    IpoFlexibleTableModule,
    IpoFilterByPropertiesPipe,
    IpoSortByPipe,
    SharedModule,
    IpoTranslatePipe,
    IpoTranslateArrayPipe,
    IpoInputComponent,
    IpoPaginationComponent,
    IpoIconAlertComponent,
    IpoModalComponent,
    IpoButtonComponent,
    IpoCheckboxComponent,
    IpoFormDatepickerComponent,
    IpoFormInputComponent,
    IpoSkeletonComponent,
    IpoPageHeaderComponent,
    GcIconComponent,
    IpoTextComponent,
    GcModalComponent,
    ErrorInformationComponent,
    GcButtonComponent,
    GcTooltipComponent,
    FeedbackAlertComponent,
    DetailedErrorFeedbackAlertComponent,
    CompleteReportConfirmationModalComponent,
    GcHeaderComponent,
    GcTabComponent,
    GcTabsComponent,
    GroupAgreementsTableComponent,
  ],
  providers: [
    {
      provide: IpoStringService,
      useFactory: stringServiceFactory({ en, sv, fi }),
      deps: [IpoLanguageService],
    },
  ],
})
export class InstallationReportingAppModule {}
